export function updateMain(status, dataFlightCar, dataMainOld, settingProject, setDataMain) {
    let data = {};
    let price = {};

    Object.keys(dataFlightCar).map((value) => {

        if (dataFlightCar[value].length > 0) {
            data[value] = [...dataFlightCar[value]];
            price[value] = 0;
        }
    })

    checkData(data, data, price, settingProject);

    return [data, price];
}

function checkData(data, updateData, updatePrice, settingProject) {
    if ('fa' in data && data['fa'].length && !('fr' in data)) {
        updateData['extraFlight'] = "תוספת על צד אחד";
        updatePrice['extraFlight'] = settingProject['oneSideAway'];
    }

    if ('fr' in data && data['fr'].length && !('fa' in data)) {
        updateData['extraFlight'] = "תוספת על צד אחד";
        updatePrice['extraFlight'] = settingProject['oneSideBack'];       
    }

    if ('ca' in data && data['ca'].length) {
        if (! ('fa' in data && data['fa'].length)) {
            updateData['extraCarA'] = 'תוספת על נ"פ הלוך';
            updatePrice['extraCarA'] = 20;
        }
    }

    if ('cr' in data && data['cr'].length) {
        if (! ('fr' in data && data['fr'].length)) {
            updateData['extraCarR'] = 'תוספת על נ"פ הלוך';
            updatePrice['extraCarR'] = 20;
        }
    }

}